export class Aula {
  id?: number;
  nome?: string;
  descrizione?: string;
  id_sede?: number;
}
